import React from "react";
import OnboardingScreen, { OnboardingTitle } from "../OnboardingScreen";
import { OnboardingNextButton } from "../OnboardingButtons";
import { OnboardingRadioRow } from "../OnboardingRows";
import { COMPETITION_LEVELS, CompetitionLevel } from "../onboardingCopy";

interface CompetitionLevelStepProps {
  value: CompetitionLevel | null;
  progress: number | null;
  showBack: boolean;
  onSelect: (value: CompetitionLevel) => void;
  onBack: () => void;
  onContinue: () => void;
}

const CompetitionLevelStep: React.FC<CompetitionLevelStepProps> = ({ value, progress, showBack, onSelect, onBack, onContinue }) => (
  <OnboardingScreen
    progress={progress}
    showBack={showBack}
    onBack={onBack}
    scroll
    width="medium"
    footer={<OnboardingNextButton label="Continue" enabled={value !== null} onClick={onContinue} />}
  >
    <div className="flex flex-col gap-7">
      <OnboardingTitle
        title="What level do you compete at?"
        subtitle="This information guides the level of insights provided and can be changed as you progress."
      />
      <div className="grid grid-cols-1 gap-3 lg:grid-cols-2" role="radiogroup" aria-label="Competition level">
        {COMPETITION_LEVELS.map((option) => (
          <OnboardingRadioRow key={option} title={option} selected={value === option} onClick={() => onSelect(option)} />
        ))}
      </div>
    </div>
  </OnboardingScreen>
);

export default CompetitionLevelStep;
